import { Skeleton } from "@circleco/compass/components/Skeleton";

interface SkeletonLoaderProps {
  count: number;
}

export const SkeletonLoader = ({ count }: SkeletonLoaderProps) => (
  <ul className="flex list-none items-center justify-center gap-2">
    {Array.from({ length: count }, (_, index) => (
      <li key={`skeleton-${String(index)}`}>
        <Skeleton shape="square" className="h-8 w-16" />
      </li>
    ))}
  </ul>
);
